import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, DELETE } from "const"
import { MtDriveFolder } from "server/models"
import {
    hasAccess,
    hasProjectAccess,
    replaceHistoryState,
} from "client/utils"
import {
    PRM_DRIVE,
    DRIVE_ACTION_CLEAR_RECYCLE,
    StoreType,
    CreateRootFolder,
    CreateRecycleFolder,
    setDrivePath,
    setDriveAction,
    createDriveUrl,
    isRecycleOpened,
    isProjectFolderOpened,
    addModal,
} from "client/store"
import {
    Button,
    PopupMenu,
    PopupMenuItem,
} from "client/components"

import FileAdd from "client/pages/drive/fileAdd"

import {
    SearchPanelWrapper,
    ActionButtonWrapper,
} from "./styled"

import SearchBar from "./search"
import { AddFolder } from "../actions/add"

const SearchPanel = () => {
    const drivePath = useSelector((state: StoreType) => state.drive.drivePath)
    const baseRoute = useSelector((state: StoreType) => state.drive.baseRoute)
    const onSelectFile = useSelector((state: StoreType) => state.drive.onSelectFile)
    const onSelectFiles = useSelector((state: StoreType) => state.drive.onSelectFiles)
    const onSelectVersion = useSelector((state: StoreType) => state.drive.onSelectVersion)
    const onSelect = onSelectFile || onSelectFiles || onSelectVersion

    const folderList = useSelector((state: StoreType) => state.drive.folder.folderList)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [showPopup, setShowPopup] = useState(false)
    const [popupTarget, setPopupTarget] = useState<HTMLElement>(null)

    const hideMenu = () => {
        setShowPopup(false)
    }

    useEffect(() => {
        document.addEventListener("click", hideMenu)
        return () => document.removeEventListener("click", hideMenu)
    }, [])

    const openRecycle = () => {
        const rootFolder = CreateRootFolder(lang)
        const recycle = CreateRecycleFolder(lang)

        const newDrivePath: MtDriveFolder[] = [rootFolder, recycle]
        dispatch(setDrivePath(newDrivePath))

        const url = createDriveUrl(newDrivePath, baseRoute)
        if (!onSelect) replaceHistoryState(url)
    }

    const projectId = isProjectFolderOpened(drivePath)

    const accountAddAccess = hasAccess(PRM_DRIVE, ADD)
    const projectAddAccess = hasProjectAccess(PRM_DRIVE, ADD, projectId)
    const addAccess = !projectId
        ? accountAddAccess
        : projectAddAccess

    const accountDeleteAccess = hasAccess(PRM_DRIVE, DELETE)
    const projectDeleteAccess = hasProjectAccess(PRM_DRIVE, DELETE, projectId)
    const deleteAccess = !projectId
        ? accountDeleteAccess
        : projectDeleteAccess

    const recycleOpened = isRecycleOpened(drivePath)

    return (
        <SearchPanelWrapper>
            <SearchBar />
            {
                deleteAccess && recycleOpened && (
                    <ActionButtonWrapper>
                        <Button
                            variant="success"
                            onClick={(e) => {
                                e.stopPropagation()
                                dispatch(setDriveAction(DRIVE_ACTION_CLEAR_RECYCLE))
                            }}
                        >
                            {lang.emptyRecycleBin}
                        </Button>
                    </ActionButtonWrapper>
                )
            }
            {
                !recycleOpened && (
                    <ActionButtonWrapper>
                        {
                            !project.id && (
                                <Button
                                    row={addAccess}
                                    disabled={!!onSelect}
                                    onClick={openRecycle}
                                >
                                    {lang.recycleBin}
                                </Button>
                            )
                        }
                        {
                            addAccess && (
                                <Button
                                    variant="success"
                                    disabled={!drivePath}
                                    after
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setShowPopup(true)
                                        setPopupTarget(e.currentTarget as HTMLElement)
                                    }}
                                >
                                    {lang.add}
                                </Button>
                            )
                        }

                        <PopupMenu
                            show={showPopup}
                            target={popupTarget}
                            placement="bottom-end"
                            showArrow={false}
                        >
                            <PopupMenuItem
                                onClick={() => dispatch(addModal({
                                    key: "addFile",
                                    content: <FileAdd />,
                                }))}
                            >
                                {lang.addFile_s}
                            </PopupMenuItem>
                            <PopupMenuItem onClick={() => AddFolder(drivePath, baseRoute, userData, folderList, lang, dispatch)}>
                                {lang.addFolder}
                            </PopupMenuItem>
                        </PopupMenu>
                    </ActionButtonWrapper>
                )
            }
        </SearchPanelWrapper>
    )
}
export default SearchPanel
